var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userhome"},[_c('div',{staticClass:"left"},[_c('user_home_tasknum'),_c('user_home_taskList',{staticStyle:{"flex":"1"}})],1),_c('div',{staticClass:"right"},[_c('user_home_remind')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }